/**
 * Copyright © Veeam Software Group GmbH.
 */

export const DEFAULT_DATA_TRANSFER_GB = 100;
